import { View, ViewOpts } from '@play-co/timestep-core/ui';
import Match2TournamentResultItem from './Match2TournamentResultItem';
import { Match2TournamentPrize } from './Match2TournamentPrize';
import * as match2TournamentGetters from 'src/replicant/match2/tournament/match2-tournament.getters';

export default class Match2TournamentResultReward extends Match2TournamentResultItem {
  private readonly prize: Match2TournamentPrize;

  constructor(opts: ViewOpts, label: string) {
    super(opts, label);
    this.prize = new Match2TournamentPrize({
      superview: this,
      width: 180,
      height: 144,
      x: -180 / 2,
      y: -144 / 2,
      visible: false,
    });
  }

  public showReward(rank: number) {
    const rewards = match2TournamentGetters.getRewardsByRank(rank);
    if (rewards.length > 0) {
      this.enable();
      this.prize.show();
      this.prize.setup(rewards, { itemSize: 80, labelSize: 30 });
    } else {
      this.disable();
      this.prize.hide();
    }
    this.show();
  }
}
